import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { Direction } from 'radix-ui';
import { StrictMode, type ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { NewVersionBanner, RouteError } from './components/new-version-banner';
import './index.css';
import { useLanguage } from './lib/i18n';
import { installStaleBuildRecovery } from './lib/stale-build';
import { routeTree } from './routeTree.gen';

installStaleBuildRecovery();

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 10_000 } },
});
const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  defaultErrorComponent: RouteError,
});

/** Radix menus, tabs and arrow keys follow the app's writing direction (document 15). */
function DirectionRoot({ children }: { children: ReactNode }) {
  const lang = useLanguage();
  return <Direction.Provider dir={lang === 'ar' ? 'rtl' : 'ltr'}>{children}</Direction.Provider>;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <DirectionRoot>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <NewVersionBanner />
      </QueryClientProvider>
    </DirectionRoot>
  </StrictMode>,
);
